interface AccessibleChartSummaryProps {
  caption: string;
  categoryHeader: string;
  valueHeader: string;
  rows: Array<{ label: string; value: string | number }>;
}

/** Provides the chart's full data as a table for assistive technology. */
export default function AccessibleChartSummary({
  caption,
  categoryHeader,
  valueHeader,
  rows,
}: AccessibleChartSummaryProps) {
  return (
    <table className="sr-only">
      <caption>{caption}</caption>
      <thead>
        <tr>
          <th scope="col">{categoryHeader}</th>
          <th scope="col">{valueHeader}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.label}>
            <th scope="row">{row.label}</th>
            <td>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
